import React from 'react';
import Image from 'next/image';

import { Link } from '@edx/components/link';
import { IconPlaySolid, IconAngleRight } from '@edx/components/icons';

import { PathsListItemProps } from './';

type Props = {
  items: PathsListItemProps[];
};

export const PathsList: React.FC<Props> = ({ items }) => (
  <ul className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-4">
    {items.map(({ name, img, resourcePath, videosCount }) => (
      <li key={resourcePath} className="relative group hover:bg-gray-600 hover:bg-opacity-10 transition duration-150">
        <Link href={resourcePath}>
          <div className="relative group h-48">
            <Image className="h-full object-cover" loading="eager" layout="fill" src={img} alt={name} />

            <div className="absolute inset-0 flex flex-col justify-between p-2 bg-gray-800 bg-opacity-60 group-hover:bg-opacity-0 transition duration-150">
              <div className="flex">
                <div className="p-2 bg-gray-800 rounded opacity-0 group-hover:opacity-100 transition-all duration-200 ease transform translate-y-3 group-hover:translate-y-0">
                  <IconPlaySolid className="text-primary-500 w-6" />
                </div>
              </div>
            </div>
          </div>

          <div className="absolute inset-0 flex flex-col justify-end font-body text-gray-500 p-2 space-y-2">
            <header className="text-4xl md:text-3xl lg:text-4xl uppercase font-display text-gray-300 leading-tight">
              {name}
            </header>

            <span className="text-xs uppercase tracking-widest font-medium leading-relaxed">{videosCount} Videos</span>

            <footer className="block md:hidden text-sm text-gray-300 font-medium flex">
              Acceder <IconAngleRight className="w-3" />
            </footer>
          </div>
        </Link>
      </li>
    ))}
  </ul>
);
